import { render, staticRenderFns } from "./zhjyEditor.vue?vue&type=template&id=0824a8cc"
import script from "./zhjyEditor.vue?vue&type=script&lang=js"
export * from "./zhjyEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0824a8cc')) {
      api.createRecord('0824a8cc', component.options)
    } else {
      api.reload('0824a8cc', component.options)
    }
    module.hot.accept("./zhjyEditor.vue?vue&type=template&id=0824a8cc", function () {
      api.rerender('0824a8cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/zhjyEditor.vue"
export default component.exports